export enum NotificationType {
    PushNotification = 'PushNotification',
    Info = 'Info',
    Error = 'Error',
}
